import { render, staticRenderFns } from "./Reproductor.vue?vue&type=template&id=c8ffbba0&scoped=true&"
import script from "./Reproductor.vue?vue&type=script&lang=js&"
export * from "./Reproductor.vue?vue&type=script&lang=js&"
import style0 from "./Reproductor.vue?vue&type=style&index=0&id=c8ffbba0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ffbba0",
  null
  
)

export default component.exports